import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Rating } from 'primereact/rating';
import { Tag } from 'primereact/tag';
import { useParams } from 'react-router-dom';
import { TabView, TabPanel } from 'primereact/tabview';
import { API_GET_COMPANYBYID, API_GET_WABAHEALTH } from '../../api/company.service';
import { Fieldset } from 'primereact/fieldset';
import { DataView } from 'primereact/dataview';
import { Chip } from 'primereact/chip';
import { Skeleton } from "primereact/skeleton";


const StatusCard = ({ data }) => {
    const iconColors = [
      {
        status: ["active", "connected", "green"],
        color: "#4DAD01",
      },
      {
        status: ["flagged", "yellow"],
        color: "#F5B379",
      },
      {
        status: ["banned", "red"],
        color: "#E61E50",
      },
      {
        status: ["unavailabel"],
        color: "#808080",
      },
      {
        status: ["unknown"],
        color: "#B0B0B2",
      },
    ];
    const getIconColor = (status) => {
      for (let i = 0; i < iconColors.length; i++) {
        if (iconColors[i].status.includes(status)) {
          return iconColors[i].color;
        }
      }
    };
    const getTitle = (status) => {
      switch (status) {
        case "green":
          return "High";
        case "yellow":
          return "Medium";
        case "red":
          return "low";
        default:
          return status;
      }
    };
    return (
      <div className={`mr-4`}>
        <h4 className="m-0 white-space-nowrap capitalize">
          {data?.icon && (
            <i
              className={`${data.icon} text-xs mr-2 `}
              style={{ color: getIconColor(data?.status) || "inherit" }}
            />
          )}
  
          <span>{getTitle(data?.status)}</span>
        </h4>
  
        <p className="mt-1 mb-0 text-sm white-space-nowrap">{data.label}</p>
      </div>
    );
  };

export const WabaHealth = () => {
    const [loading, setLoading] = useState(false);
  const [wabaHealthInfo, setWabaHealth] = useState(null);
  const { companyId } = useParams();

  useEffect(() => {
    setLoading(true);
    API_GET_WABAHEALTH(companyId)
      .then((data) => {
        let wabaHealth = data?.wabaInfo;
        const details = [
          {
            icon: "pi pi-circle-fill",
            status: wabaHealth?.accountStatus?.toLowerCase() || "N/A",
            label: "Account Status",
            id: "akannw234",
          },
          {
            icon: "pi pi-circle-fill",
            status: wabaHealth?.dockerStatus?.toLowerCase() || "N/A",
            label: "Docker Status",
            id: "akannw235",
          },
          {
            icon: "",
            status: wabaHealth?.messagingLimit?.toLowerCase() || "N/A",
            label: "Message limit",
            id: "akannw236",
          },
          {
            icon: "pi pi-circle-fill",
            status: wabaHealth?.phoneQuality?.toLowerCase() || "N/A",
            label: "Phone Quality",
            id: "akannw237",
          },
        ];

        if (wabaHealth?.accountStatus?.toLowerCase() == "banned") {
          setWabaHealth([details[0]]);
        } else {
          setWabaHealth(details);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err.response.data.message);
      });
  }, []);


    return (
        <div>
          {loading ? (
            <Skeleton width="w-full" height="3rem"></Skeleton>
          ) : (
            <div className="flex gap-4 align-items-end">
              {wabaHealthInfo?.map((item, i) => (
                <StatusCard key={item?.id || i} data={item} />
              ))}
            </div>
          )}
        </div>
      );
}
